// extracted by mini-css-extract-plugin
module.exports = {"root":"BeingIn_root__j_744","title":"BeingIn_title__p4wE5","image":"BeingIn_image__kzBGH","imageContainer":"BeingIn_imageContainer__3T9Ly"};